import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestJobExecute = {
    path: "/job/:id",
    method: RouteHttpVerb.POST
};
